module.exports = __webpack_public_path__ + "static/media/postpartum.184e9ad0.svg";